var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "my-info"
  }, [_c('p', {
    staticClass: "intro"
  }, [_vm._v(_vm._s(_vm.$k18n({
    id: 'k_341727'
  })))]), _c('ul', {
    staticClass: "info"
  }, [_c('li', [_c('p', {
    class: {
      label: true,
      zh: _vm.isZh
    }
  }, [_vm._v(_vm._s(_vm.$k18n({
    id: 'k_342205'
  })))]), _c('p', {
    staticClass: "num"
  }, [_c('k-image', {
    attrs: {
      "src": "//cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/tick.png",
      "alt": ""
    }
  }), _c('i', [_vm._v(_vm._s(_vm.store.homeData.allPointTake))])], 1)]), _c('li', [_c('p', {
    class: {
      label: true,
      zh: _vm.isZh
    }
  }, [_vm._v(_vm._s(_vm.$k18n({
    id: 'k_342206'
  })))]), _c('p', {
    staticClass: "num"
  }, [_c('k-image', {
    attrs: {
      "src": "//cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/tick.png",
      "alt": ""
    }
  }), _c('i', [_vm._v(_vm._s(_vm.store.homeData.point))])], 1)])]), _c('div', {
    staticClass: "records"
  }, [_c('p', {
    staticClass: "btn",
    on: {
      "click": _vm.openRecord
    }
  }, [_vm._v(_vm._s(_vm.$k18n({
    id: 'k_333271'
  })))])]), _c('div', {
    staticClass: "go-vote"
  }, [_c('span', {
    class: {
      disabled: !_vm.store.homeData.point
    },
    on: {
      "click": _vm.goToVote
    }
  }, [_vm._v(_vm._s(_vm.$k18n({
    id: 'k_333267'
  })))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }